export enum PostalAreaActions {
  EDIT = "EDIT",
  DELETE = "DELETE",
}
